import PropTypes from "prop-types";
import { Button, Box, Typography, useTheme } from "@mui/material";
import {
  downloadPDF,
  downloadXMLSingle,
} from "../../../utils/downloadFiles.ts";

import "./DownloadCard.scss";
import PDF from "../../../assets/PDF.svg";
import XML from "../../../assets/xml.svg";
import XMLResponse from "../../../assets/XML-resp.svg";
import { useElectronic } from "../../../context/ElectronicContext";

function DownloadCard({ incomeID, setModalOpen }) {
  const theme = useTheme();
  const { LineDetailPlace } = useElectronic();
  const isDarkModeEnabled = theme.palette.mode === "dark";

  const handleDownloadPdf = async type => {
    await downloadPDF(incomeID, LineDetailPlace.id);
    setModalOpen(false);
  };
  const handleDownloadXml = async resp => {
    await downloadXMLSingle(incomeID, resp);
    setModalOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minWidth: "400px",
        height: "360px",
        gap: "1.5rem",
        backgroundColor: isDarkModeEnabled
          ? "rgba(9,25,40,0.6)"
          : "rgba(255,255,255,0.1)",
        backdropFilter: isDarkModeEnabled ? "blur(24px)" : "blur(5px)",
      }}
    >
      <br />
      <Typography fontSize={20} fontWeight="bold" variant="h3">
        Descargar
      </Typography>
      <Button
        className={`btn-download ${isDarkModeEnabled ? "dark-mode" : "light-mode"}`}
        sx={{
          width: "80%",
          height: "16%",
        }}
        onClick={() => handleDownloadPdf()}
      >
        <img
          alt=""
          className={`img-download ${isDarkModeEnabled ? "" : " light-mode"}`}
          src={PDF}
        />
        PDF
      </Button>
      <Button
        className={`btn-download ${isDarkModeEnabled ? "dark-mode" : "light-mode"}`}
        sx={{
          width: "80%",
          height: "16%",
        }}
        onClick={() => handleDownloadXml(false)}
      >
        <img
          alt=""
          className={`img-download ${isDarkModeEnabled ? "" : " light-mode"}`}
          src={XML}
        />
        XML
      </Button>
      <Button
        className={`btn-download ${isDarkModeEnabled ? "dark-mode" : "light-mode"}`}
        sx={{
          width: "80%",
          height: "16%",
        }}
        onClick={() => handleDownloadXml(true)}
      >
        <img
          alt=""
          className={`img-download ${isDarkModeEnabled ? "" : " light-mode"}`}
          src={XMLResponse}
        />
        XML de respuesta
      </Button>
    </Box>
  );
}

DownloadCard.propTypes = {
  incomeID: PropTypes.string.isRequired,
  setModalOpen: PropTypes.func.isRequired,
};

export default DownloadCard;
